exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-field,\r\n.filter-operator {\r\n    padding-top: 7px;\r\n    padding-bottom: 6px;\r\n    min-width: 80px;\r\n    width: auto;\r\n}\r\n.filter-button,\r\n.clear-filter-button {\r\n    background-color: #0563b8;\r\n}\r\n.filter-value {\r\n    width: 200px;\r\n}\r\n.filter-value-numeric {\r\n    width: 150px;\r\n}\r\n.k-textbox {\r\n    /* min-width: 80px; */\r\n    width: auto;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n}\r\n.form-inline * {\r\n    margin-right: 5px;\r\n}\r\n@media (max-width: 576px) {\r\n    .form-inline {\r\n        gap: 5px;\r\n        -webkit-box-pack: justify;\r\n            -ms-flex-pack: justify;\r\n                justify-content: space-between;\r\n    }\r\n\r\n    .form-inline * {\r\n        margin: 0;\r\n    }\r\n\r\n    .k-button {\r\n        padding: 8px 12px;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-filter-menu/djiv-filter-menu.component.css
// module id = ../../../../../src/app/shared/components/djiv-filter-menu/djiv-filter-menu.component.css
// module chunks = main